<template>
  <div class="scroll-tree">
    <div class="trees">
      <div
        class="tree"
        :class="{ white: !currentChildren.id }"
        @click="
          onSelect({
            id: '',
            name: '',
            parentId: '',
            categoryLevel: 0,
            children: [],
            courseNum: '',
            count: '',
            hasChildren: 0
          })
        "
      >
        <div class="tree-line" v-if="!currentChildren.id"></div>
        <div class="tree-name" :class="{ active: !currentChildren.id }">{{ $t('all') }}</div>
      </div>
    </div>
    <div
      class="trees"
      :class="{ white: treeItem.id === currentTree.id }"
      v-for="treeItem in dataTree"
      :key="treeItem.id"
    >
      <div class="tree" @click="onSelect(treeItem as unknown as TreeItem)">
        <div class="tree-line" v-if="treeItem.id === currentChildren.id"></div>
        <div
          class="tree-name"
          :class="{ active: treeItem.id === currentChildren.id, tree_name_black: treeItem.id === currentTree.id }"
        >
          {{ treeItem.name }}
        </div>
        <i
          class="iconfont icon-shouqijiantou"
          :class="treeItem.isOpen ? 'tree-right-open' : 'tree-right-close'"
          v-if="isFold && treeItem.children.length"
        ></i>
      </div>
      <template v-if="treeItem.isOpen || !isFold">
        <div
          class="tree"
          v-for="childrenItem in treeItem.children"
          :key="childrenItem.id"
          @click="onSelect(treeItem as unknown as ThildrenItem, childrenItem as unknown as ThildrenItem)"
        >
          <div class="tree-line" v-if="childrenItem.id === currentChildren.id && !isFold"></div>
          <div class="tree-children-name" :class="{ active: childrenItem.id === currentChildren.id }">
            {{ childrenItem.name }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
import { useThemeColor } from '@/utils/theme'
import { TreeItem, ThildrenItem } from '../types'
import { LmsCourseCategory } from '@/api/Models/CourseDetail'
import { useRoute } from 'vue-router'

// eslint-disable-next-line
const props = defineProps<{
  data: LmsCourseCategory[]
  // defaultSelectedId?: string
}>()
const route = useRoute()
// const router = useRouter()
const isFold = ref(true)
const dataTree = ref(props.data)
// const defaultSelectedId = ref(props.defaultSelectedId)
const emits = defineEmits(['onSelectTree'])
const currentTree = ref<TreeItem | ThildrenItem>({
  id: '',
  name: '',
  parentId: '',
  categoryLevel: 0,
  children: [],
  courseNum: '',
  count: '',
  hasChildren: 0
})
const currentChildren = ref<TreeItem>({
  id: '',
  name: '',
  parentId: '',
  categoryLevel: 0,
  children: [],
  courseNum: '',
  count: '',
  hasChildren: 0
})
const themeColor = useThemeColor()
const onSelect = (treeItem: TreeItem, childrenItem?: ThildrenItem) => {
  if (!childrenItem && isFold.value) {
    treeItem.isOpen = !treeItem.isOpen
  }
  const _currentChildren = childrenItem || treeItem
  if (currentChildren.value.id === _currentChildren.id) {
    return
  }
  // router.replace({
  //   path: route.path,
  //   query: {
  //     category: _currentChildren.id
  //   }
  // })
  // defaultSelectedId.value = _currentChildren.id
  currentTree.value = treeItem
  currentChildren.value = _currentChildren
  emits('onSelectTree', currentChildren.value)
}

watch(
  () => props.data,
  (newValue) => {
    dataTree.value = newValue.map((item) => {
      return {
        ...item,
        isOpen: false
      }
    })
  },
  {
    deep: true,
    immediate: true
  }
)

const findItemById = (
  items: LmsCourseCategory[],
  id: string
): { treeItem: LmsCourseCategory; childrenItem?: LmsCourseCategory } | undefined => {
  for (const item of items) {
    if (item.id === id) {
      return { treeItem: item }
    }
    if (item.children) {
      const foundInChildren = findItemById(item.children, id)
      if (foundInChildren) {
        return { treeItem: item, childrenItem: foundInChildren.treeItem }
      }
    }
  }
  return undefined
}

watch(
  () => [route.query.category, dataTree.value],
  (newValue) => {
    if (newValue[0] && newValue[1]) {
      const foundItem = findItemById(newValue[1], newValue[0])
      if (foundItem) {
        onSelect(foundItem.treeItem, foundItem.childrenItem)
        if (foundItem.treeItem.parentId === '0') {
          foundItem.treeItem.isOpen = true
        } else {
          const parentItem = findItemById(newValue[1], foundItem.treeItem.parentId)
          if (parentItem) {
            parentItem.treeItem.isOpen = true
          }
        }
      }
    }
  },
  {
    immediate: true
  }
)

// watch(
//   () => dataTree.value,
//   (newValue) => {
//     if (defaultSelectedId.value) {
//       const foundItem = newValue.find((item) => item.id === defaultSelectedId.value)
//       foundItem && onSelect(foundItem as unknown as TreeItem)
//     }
//   }
// )

// onActivated(() => {
//   const category = route.query.category as string
//   // 如果当前选中的分类和默认选中的分类相同，则不进行操作
//   if (defaultSelectedId.value === category || !category) {
//     return
//   }
//   defaultSelectedId.value = category
//   const foundItem = dataTree.value.find((item) => item.id === category)
//   if (foundItem) {
//     onSelect(foundItem as unknown as TreeItem)
//   } else {
//     console.log('选择全部')
//     onSelect({
//       id: '',
//       name: '',
//       parentId: '',
//       categoryLevel: 0,
//       children: [],
//       courseNum: '',
//       count: '',
//       hasChildren: 0
//     })
//   }
// })
</script>
<style scoped lang="less">
.scroll-tree {
  width: 102px;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #ebedf0;
  .trees {
    background: #f4f5f7;
    margin-bottom: 5px;
  }
  .tree {
    display: flex;
    align-items: center;
    // justify-content: center;
    position: relative;
    margin-bottom: 4px;
    padding: 10px 10px;
    text-align: center;
    word-break: break-all;
  }
  .tree-line {
    width: 4px;
    height: 15px;
    background: v-bind(themeColor);
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 0px 2px 2px 0px;
  }

  .tree-right-close {
    width: 12px;
    height: 12px;
    font-size: 12px;
    color: #d7d7d7;
    margin-left: auto;
    transform: rotate(180deg);
  }
  .tree-right-open {
    width: 12px;
    height: 12px;
    font-size: 12px;
    color: #d7d7d7;
    margin-left: auto;
  }

  .tree-name {
    // color: #171921;
    color: #61666d;
    font-weight: 500;
    word-break: break-all;
    font-size: 14px;
    flex: 1;
    text-align: left;
    padding: 0 4px;
  }
  .tree_name_black {
    color: #171921 !important;
  }
  .tree-children-name {
    color: #999999;
    word-break: break-all;
    font-size: 14px;
    text-align: left;
  }
  .white {
    background: #fff;
  }
  .active {
    color: v-bind(themeColor);
  }
}
.scroll-tree::-webkit-scrollbar {
  display: none;
}
</style>
